import { Card, Typography, Button, Container, Stack, TableContainer, TableHead, TableRow, TableCell, Checkbox, Table, Avatar, TableBody, IconButton, MenuItem, Popover, Dialog, DialogTitle, DialogContent, TextField, Paper, Box, Stepper, Step, StepLabel, FormControl, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import '../../Common_css/style.css';
import Iconify from 'src/components/iconify';
import { deleteData, formPostData, getData, patchFormData } from "src/webService/webService";
import { toast, ToastContainer } from "react-toastify";
import uploadIcon from '../../components/images/upload-placeholder.webp';
import deleteIcon from '../../components/icons/remove.png';
import Loader from "../Loader/Loader";
import { useParams } from "react-router-dom";
import uploadImg from '../../components/images/upload-placeholder.webp';


export default function Product() {

    const Token = sessionStorage.getItem('Token');
    const [productList, setProductList] = useState([]);
    const [action, setAction] = useState('');
    const [open, setOpen] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [step, setStep] = useState(1);
    const [thumbnail, setThumbnail] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        fabric_type: "",
        sizes: '',
        colors: "",
    });
    const [errors, setErrors] = useState({});
    const initialImage = uploadIcon;
    const [preview, setPreview] = useState(initialImage);
    const [imageFiles, setImageFiles] = useState([]);
    const [resId, setResId] = useState('');
    const role = sessionStorage.getItem('Role');
    const [getProductId, setGetProductId] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [resImages, setResImages] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [loader, setLoader] = useState(false);
    const { brandid } = useParams();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateStep = () => {
        let newErrors = {};
        if (step === 1) {
            if (!formData.name || !formData.name.trim()) newErrors.name = "Name is required";
            // if (!formData.email.trim()) newErrors.email = "Email is required";
            if (thumbnail == null) newErrors.thumbnail = "Thumbnail is required"
            // if (thumbnail === null) newErrors.thumbnail = 'Thumbnail is not uploaded';
        } else if (step === 2) {
            // if (!formData.fabric_type.trim()) newErrors.fabric_type = "Fabric Type is required";
            // if (!formData.colors.trim()) newErrors.colors = "Colors is required";
            // if (!formData.sizes.trim()) newErrors.sizes = "Size is required";
        }
        // else if (step === 3) {
        //     if (!formData.address.trim()) newErrors.address = "Address is required";
        //     if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
        // }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const nextStep = () => {
        if (validateStep()) {
            setStep(step + 1);
        }
    };

    const prevStep = () => setStep(step - 1);

    const handleSubmit = (e) => {
        e.preventDefault();
        debugger;
        const formData = new FormData();
        imageFiles.forEach((file, index) => {
            formData.append("images[]", file); // Append each file
        });


        console.log(formData, 'formdtaaaaaaaaaa');

        formPostData(`seller/${brandid}/product/${resId === '' ? getProductId : resId}/gallery`, formData, Token)
            .then((res) => {
                getProducts(currentPage);
                toast.success('Product Added successfully');
                handleClose();
                setImageFiles([]);
            })
            .catch((error) => {
                console.error("Error:", error);
            });

    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    const handleProduct = () => {
        debugger;
        const newFormData = new FormData();
        if (thumbnail === null) {

        } else {
            newFormData.append("thumbnail", thumbnail);
        }
        newFormData.append("name", formData.name || '');
        newFormData.append("sizes", formData.sizes || '');
        newFormData.append("fabric_type", formData.fabric_type || '');
        newFormData.append("colors", formData.colors || '');

        if (action === 'Add') {
            formPostData(`seller/${brandid}/products`, newFormData, Token)
                .then((res) => {
                    setAction('Add-Gallery')
                    getProducts();
                    toast.success('Product created successfully');
                    setResId(res._id)
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        } else if (action === 'Edit' || action === 'Add-Gallery') {
            patchFormData(`seller/${brandid}/products/${getProductId}`, newFormData, Token)
                .then((res) => {
                    getProducts(currentPage);
                    toast.success('Product gallery updated successfully');
                    setResId(res._id);
                    handleClose();
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }

    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setThumbnail(file);
        }
    };

    const [images, setImages] = useState([]);

    // const handleGalleryImageChange = (event) => {
    //     const files = event.target.files;
    //     if (files.length > 0) {
    //         const newImages = Array.from(files).map((file) =>
    //             URL.createObjectURL(file)
    //         );
    //         setImages((prevImages) => [...prevImages, ...newImages]);
    //     }
    // };

    const handleGalleryImageChange = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
            const newImages = files.map((file) => URL.createObjectURL(file));

            setImages((prevImages) => [...prevImages, ...newImages]);
            setImageFiles((prevFiles) => [...prevFiles, ...files]); // Store files for FormData
        }
    };

    // const handleRemoveImage = async (index, status, url) => {
    //     debugger;
    //     // setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    //     // setImageFiles((prevImages) => prevImages.filter((_, i) => i !== index));
    //     if (status === 'delete') {
    //         setResImages((prevImages) => prevImages.filter((_, i) => i !== index));
    //         const params = url;
    //         const trimmedUrl = params.replace("https://srma.digitaltriumph.co.in/public/storage/", "");
    //         try {
    //             const res = await deleteData(`seller/product/${getProductId}/gallery?image=${trimmedUrl}`, Token);
    //             getProducts();
    //             // toast.success('category deleted successfully')
    //         } catch (error) {
    //             console.error("Error:", error);
    //             toast.error("An error occurred. Please try again later.", {});
    //         }
    //     }
    // };

    const handleRemoveImage = async (e, index, status, url) => {
        e.preventDefault(); // 👈 Prevent the default behavior
        debugger;

        if (status === 'delete') {
            setResImages((prevImages) => prevImages.filter((_, i) => i !== index));
            const trimmedUrl = url.replace("https://srma.digitaltriumph.co.in/public/storage/", "");

            try {
                const res = await deleteData(`seller/${brandid}/product/${getProductId}/gallery?image=${trimmedUrl}`, Token);
                getProducts(currentPage);
            } catch (error) {
                console.error("Error:", error);
                toast.error("An error occurred. Please try again later.");
            }
        }
    };

    const handleOpenMenu = (event, id) => {
        setOpen(event.currentTarget);
        getProductsById(id);
    };

    const handleCloseMenu = () => {
        setOpen(null);
    }

    const handleOpenModal = (status) => {
        debugger
        if (status === 'View') {
            setStep(3);
        }
        setOpenModal(true);
        if (status === 'Add') {
            setFormData('');
            setPreview(uploadIcon);
            setStep(1)
            setOpen(null);
            setImages([]);
            setResImages([]);
        }
    }

    const handleClose = () => {
        setOpenModal(false);
        setFormData('');
        setPreview(uploadIcon);
        setStep(1)
        setOpen(null);
        setImages([]);
    }


    const getProducts = async (page) => {
        setLoader(true)
        const params = {
            page: page,
            per_page: limit,
        }
        try {
            if (role === 'Seller') {
                const res = await getData(`seller/${brandid}/products`, params, Token);
                if (res.status === 200) {
                    console.log(res.data, "res.data");
                    setProductList(res.data);
                    setTotalItems(res?.total);
                    setTotalPages(res?.last_page);
                }
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoader(false);
        }
    }


    useEffect(() => {
        getProducts(currentPage);
    }, [limit, currentPage, brandid])


    const getProductsById = async (id) => {

        try {
            if (role === 'Admin') {
                const res = await getData(`sellers/products/${id}`, null, Token);
                if (res.status === 200) {
                    console.log(res.data, "res.data");
                    // setProductList(res.data)
                }
            } else if (role === 'Seller') {
                const res = await getData(`seller/${brandid}/products/${id}`, null, Token);
                if (res.status === 200) {
                    console.log(res.data, "res.data");
                    // setProductList(res.data)
                    setPreview(res?.thumbnail);
                    setFormData({
                        name: res?.name,
                        fabric_type: res?.fabric_type,
                        sizes: res?.sizes,
                        colors: res?.colors,
                    });
                    setResImages(res?.galleryFiles)

                }
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    console.log(resImages, 'resssssssimagaaaaeeeeeeeeeeeeeee');


    const handleOpenDeleteModal = () => {
        setOpenDeleteModal(true);
    }

    const handleDeleteClose = () => {
        setOpenDeleteModal(false);
        handleCloseMenu();
    }

    const deleteProduct = async () => {
        try {
            const res = await deleteData(`seller/${brandid}/products/${getProductId}`, Token);
            getProducts(currentPage);
            handleDeleteClose();
            handleCloseMenu();
            // toast.success('category deleted successfully')
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }



    return (
        <>
            <ToastContainer position="top-right" />
            <Helmet>
                <title> Products</title>
            </Helmet>

            <div className='p-0 ProductPage'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" className='title-color' gutterBottom>
                        Product
                    </Typography>
                    <Button variant="contained" className='Button' onClick={(event) => { handleOpenModal('Add'); setAction('Add') }} startIcon={<Iconify icon="eva:plus-fill" />}>
                        New Product
                    </Button>
                </Stack>

                {loader ? (
                    <Loader />
                ) : (
                    <Card className='card-bg'>
                        <TableContainer style={{ height: "420px", overflowY: "scroll", width: "100%" }}>
                            <Table stickyHeader style={{ width: "100%" }}>
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell className="table-cl color-dark mx-5" align="center">
                                            S.No
                                        </TableCell> */}
                                        {/* <TableCell className="table-cl color-dark" width='20%'>
                                            Product Thumbnail
                                        </TableCell> */}
                                        <TableCell className="table-cl color-dark mx-20" width= '20%'>
                                            Product Name
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Product Fabric Type
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-20">
                                            Product Color
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-15">
                                            Gallery Image
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productList?.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell className="table-cl color-dark mx-20" width='5%' align="center">
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    gap={1}
                                                >
                                                    {item?.thumbnail ? (
                                                        <Avatar src={item?.thumbnail}></Avatar>
                                                    ) : (
                                                        <Avatar>
                                                            {item.name
                                                                ? item.name[0]
                                                                : null}
                                                        </Avatar>
                                                    )}
                                                    {item?.name}
                                                </Stack>
                                            </TableCell>                            
                                            <TableCell className="table-cl color-dark mx-10">
                                                {item?.fabric_type ? item?.fabric_type : '--'}
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-20">
                                                {item?.colors ? item?.colors : '--'}
                                            </TableCell>
                                            {/* <TableCell className="table-cl color-dark mx-15 d-flex" height='77px'>
                                                {item.galleryFiles.length === 0 ? (
                                                    <p>No Gallery Images</p>
                                                ) : (
                                                    item.galleryFiles.map((file, index) => (
                                                        <Avatar key={index} src={file} />
                                                    ))
                                                )}
                                            </TableCell> */}
                                            <TableCell className="table-cl color-dark mx-15 d-flex" height="77px">
                                                {item.galleryFiles.length === 0 ? (
                                                    <p>No Gallery Images</p>
                                                ) : (
                                                    <>
                                                        {item.galleryFiles.slice(0, 3).map((file, index) => (
                                                            <Avatar key={index} src={file} />
                                                        ))}
                                                        {item.galleryFiles.length > 3 && (
                                                            <p className="ml-2 mt-2">+{item.galleryFiles.length - 3} more</p>
                                                        )}
                                                    </>
                                                )}
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                <IconButton
                                                    size="large"
                                                    color="inherit"
                                                    // style={{ position: 'absolute', top: '14px', right: '14px', padding: '6px', background: '#d0e1e9', border: '1px solid white' }}
                                                    onClick={(event) => {
                                                        handleOpenMenu(event, item?._id);
                                                        setGetProductId(item?._id)
                                                    }}
                                                >
                                                    <Iconify icon={"eva:more-vertical-fill"} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="d-flex flex-wrap justify-content-end m-3">
                            <FormControl variant="outlined" size="small" style={{ width: "6%" }}>
                                <Select
                                    labelId="limit-label"
                                    id="limit-select"
                                    value={limit}
                                    onChange={handleLimitChange}
                                >
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                    <MenuItem value={TotalItems}>All</MenuItem>
                                </Select>
                            </FormControl>
                            <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                <Iconify icon={"grommet-icons:previous"} />
                            </Button>
                            <Button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                            >
                                <Iconify icon={"grommet-icons:next"} />
                            </Button>
                        </div>
                        <Popover
                            open={Boolean(open)}
                            anchorEl={open}
                            onClose={handleCloseMenu}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 200,
                                    "& .MuiMenuItem-root": {
                                        px: 1,
                                        typography: "body2",
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem
                                onClick={() => {
                                    setAction("Edit");
                                    handleOpenModal();
                                }}
                            >
                                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                                Edit
                            </MenuItem>
                            <MenuItem
                                onClick={(event) => {
                                    setAction("View");
                                    handleOpenModal('View');
                                }}
                            >
                                <Iconify icon={"raphael:view"} sx={{ mr: 2 }} />
                                View Gallery
                            </MenuItem>
                            <MenuItem
                                sx={{ color: "error.main" }}
                                onClick={() => {
                                    handleOpenDeleteModal();
                                }}
                            >
                                <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
                                Delete
                            </MenuItem>
                        </Popover>
                    </Card>

                )}
            </div>


            <Dialog open={openModal} onClose={handleClose} maxWidth="md" fullWidth>
                <div className="d-flex justify-content-between">
                    <DialogTitle>{action} Product</DialogTitle>
                    <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px',cursor:'pointer'}} onClick={handleClose} />
                </div>
                <DialogContent>
                    <Paper elevation={3} sx={{ padding: 4, marginTop: 0, borderRadius: 2 }}>
                        <Stepper activeStep={step - 1} alternativeLabel>
                            <Step>
                                <StepLabel>Basic Product Details</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Product Attributes Details</StepLabel>
                            </Step>
                            {action === 'Edit' ? (
                                <></>
                            ) : (
                                <Step>
                                    <StepLabel>
                                        Gallery Images
                                    </StepLabel>
                                </Step>
                            )}
                        </Stepper>

                        {action === 'Edit' ? (
                            <Typography variant="h5" align="center" gutterBottom sx={{ marginTop: 2 }}>
                                Step {step} of 2
                            </Typography>
                        ) : (
                            <Typography variant="h5" align="center" gutterBottom sx={{ marginTop: 2 }}>
                                Step {step} of 3
                            </Typography>
                        )}


                        <form>
                            {step === 1 && (
                                <Box display="flex" flexDirection="column" gap={2} sx={{ marginTop: 3 }}>

                                    <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="fileInput"
                                            style={{ display: "none" }}
                                            onChange={handleImageChange}
                                        />
                                        <label htmlFor="fileInput">
                                            <img
                                                src={preview}
                                                alt="Uploaded"
                                                style={{
                                                    width: "300px",
                                                    height: "200px",
                                                    objectFit: "contain",
                                                    cursor: "pointer",
                                                    borderRadius: "10px",
                                                }}
                                            />
                                            <p className='mb-0' style={{ fontSize: '12px' }}>Upload Thumbnail image</p>
                                        </label>
                                        {errors.thumbnail && (
                                            <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                {errors.thumbnail}
                                            </p>
                                        )}
                                    </div>
                                    <TextField
                                        label="Product Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        fullWidth
                                        required
                                        error={!!errors.name}
                                        helperText={errors.name}
                                    />
                                    <Button variant="contained" onClick={nextStep} fullWidth>
                                        Next
                                    </Button>
                                </Box>
                            )}

                            {step === 2 && (
                                <Box display="flex" flexDirection="column" gap={2} sx={{ marginTop: 3 }}>
                                    <TextField
                                        label="Fabric Type (optional)"
                                        name="fabric_type"
                                        value={formData.fabric_type}
                                        onChange={handleChange}
                                        fullWidth
                                        error={!!errors.fabric_type}
                                        helperText={errors.fabric_type}
                                    />
                                    <TextField
                                        label="Size (optional)"
                                        name="sizes"
                                        value={formData.sizes}
                                        onChange={handleChange}
                                        fullWidth
                                        error={!!errors.sizes}
                                        helperText={errors.sizes}
                                    />
                                    <TextField
                                        label="Colors (optional)"
                                        name="colors"
                                        value={formData.colors}
                                        onChange={handleChange}
                                        fullWidth
                                        error={!!errors.colors}
                                        helperText={errors.colors}
                                    />
                                    <Box display="flex" justifyContent="space-between">
                                        <Button variant="outlined" onClick={prevStep}>
                                            Previous
                                        </Button>
                                        {action === 'Edit' ? (
                                            <Button variant="contained" onClick={(e) => { handleProduct() }}>
                                                Submit
                                            </Button>
                                        ) : (
                                            <Button variant="contained" onClick={(e) => { nextStep(); handleProduct() }}>
                                                Next
                                            </Button>
                                        )}
                                    </Box>
                                </Box>
                            )}

                            {step === 3 && (
                                <Box display="flex" flexDirection="column" gap={2} sx={{ marginTop: 3 }}>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            padding: "12px",
                                            border: "3px dashed #e3e3e3",
                                            borderRadius: "10px",
                                            height: '150px',
                                            background: '#f7f7f7'
                                        }}
                                    >
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="fileInput"
                                            multiple
                                            style={{ display: "none" }}
                                            onChange={handleGalleryImageChange}
                                        />
                                        <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                                            <p className="mb-0" style={{ fontSize: "12px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                Upload Gallery Images
                                            </p>
                                            <div>
                                                <img
                                                    src={uploadImg}
                                                    alt="Uploaded"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginLeft: '10px',
                                                        width: "100px",
                                                        height: "110px",
                                                        objectFit: "contain",
                                                        cursor: "pointer",
                                                        borderRadius: "10px",
                                                    }}
                                                />
                                            </div>
                                        </label>

                                        {/* Display Multiple Image Previews */}
                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                                            {images.map((image, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                    }}
                                                >
                                                    <img
                                                        src={image}
                                                        alt={`Uploaded ${index + 1}`}
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            objectFit: "cover",
                                                            borderRadius: "10px",
                                                            border: "1px solid #ddd",
                                                        }}
                                                    />
                                                    <button
                                                        onClick={(e) => handleRemoveImage(e, index, 'upload')}
                                                        style={{
                                                            position: "absolute",
                                                            top: "5px",
                                                            right: "5px",
                                                            background: "red",
                                                            color: "white",
                                                            border: "none",
                                                            borderRadius: "50%",
                                                            width: "20px",
                                                            height: "20px",
                                                            cursor: "pointer",
                                                            fontSize: "12px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>

                                        {errors.gallery && (
                                            <p
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    marginTop: "5px",
                                                }}
                                            >
                                                {errors.gallery}
                                            </p>
                                        )}
                                    </div>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                                        {resImages.map((image, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                }}
                                            >
                                                <img
                                                    src={image}
                                                    alt={`Uploaded ${index + 1}`}
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        objectFit: "cover",
                                                        borderRadius: "10px",
                                                        border: "1px solid #ddd",
                                                    }}
                                                />
                                                <button
                                                    onClick={(e) => handleRemoveImage(e, index, 'delete', image)}
                                                    style={{
                                                        position: "absolute",
                                                        top: "5px",
                                                        right: "5px",
                                                        background: "red",
                                                        color: "white",
                                                        border: "none",
                                                        borderRadius: "50%",
                                                        width: "20px",
                                                        height: "20px",
                                                        cursor: "pointer",
                                                        fontSize: "12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}
                                    </div>

                                    {/* {action === 'View' ? (
                                        {imageFiles?.length < 0 ? (
                                            <Box display="flex" justifyContent="space-between">
                                            
                                            <Button variant="contained" type="submit" onClick={handleSubmit}>
                                                Submit
                                            </Button>
                                        </Box>
                                        ) : (
                                            <Box display="flex" justifyContent="space-between">
                                                <Button variant="contained" type="submit" onClick={handleSubmit}>
                                                    Submit
                                                </Button>
                                            </Box>
                                        ) }
                                        // <></>
                                    ) : (
                                        <Box display="flex" justifyContent="space-between">
                                            <Button variant="outlined" onClick={prevStep}>
                                                Previous
                                            </Button>
                                            <Button variant="contained" type="submit" onClick={handleSubmit}>
                                                Submit
                                            </Button>
                                        </Box>
                                    )} */}

                                    {action === 'View' ? (
                                        imageFiles?.length === 0 ? ( // Fixed: Corrected the length condition
                                            // <Box display="flex" justifyContent="space-between">
                                            //     <Button variant="contained" type="submit" onClick={handleSubmit}>
                                            //         Submit
                                            //     </Button>
                                            // </Box>
                                            <></>
                                        ) : (
                                            <Box display="flex" justifyContent="end">
                                                <Button variant="contained" type="submit" onClick={handleSubmit}>
                                                    Submit
                                                </Button>
                                            </Box>
                                        )
                                    ) : (
                                        <Box display="flex" justifyContent="space-between">
                                            <Button variant="outlined" onClick={prevStep}>
                                                Previous
                                            </Button>
                                            <Button variant="contained" type="submit" onClick={handleSubmit}>
                                                Submit
                                            </Button>
                                        </Box>
                                    )}

                                </Box>
                            )}
                        </form>
                    </Paper>
                </DialogContent>
            </Dialog>
            <Dialog open={openDeleteModal} onClose={handleDeleteClose} maxWidth="sm" fullWidth>
                <DialogContent className='p-5'>
                    <div>
                        <div className='d-flex justify-content-center'>
                            <img src={deleteIcon} width='10%' />
                        </div>
                        <h4 className='text-center mt-4'>Confirm deletion?</h4>
                        <p className='text-center'>Data will be lost forever.</p>
                        <Button variant="contained" className='Button w-100 mt-3 shadow-none' onClick={(e) => deleteProduct()}>
                            Yes
                        </Button>
                        <Button variant="outlined" className='w-100 mt-3' onClick={(e) => handleDeleteClose()} >
                            No
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}